import type { Dictionary } from '../types';

const ar: Dictionary = {
  meta: {
    title: 'وكالة تطوير برمجيات الجزائر العاصمة | كودكس الجزائر',
    description:
      'استوديو تقني في الجزائر العاصمة منذ 2014 — برمجيات مخصصة، تطبيقات موبايل، مواقع، سحابة وأمن سيبراني. عرض سعر تفاعلي أونلاين. كودكس (SARL Groupe Codex).',
  },
  nav: {
    about: 'من نحن',
    services: 'الخدمات',
    work: 'أعمالنا',
    blog: 'المدونة',
    contact: 'تواصل',
    startProject: 'عرض سعر مجاني',
    menu: 'القائمة',
    close: 'إغلاق',
    skip: 'تخطّ إلى المحتوى',
    backToTop: 'كودكس — العودة للأعلى',
  },
  theme: {
    light: 'فاتح',
    dark: 'داكن',
    toLight: 'التبديل إلى الوضع الفاتح',
    toDark: 'التبديل إلى الوضع الداكن',
  },
  lang: {
    label: 'اللغة',
    en: 'EN',
    fr: 'FR',
    ar: 'عربي',
  },
  hero: {
    kicker: 'شريكك التقني الموثوق',
    status: 'منذ 2014 — مستقل',
    line1: 'نبني',
    line2: 'مستقبلًا',
    line3: 'رقميًا',
    body: 'كودكس وكالة تقنية رائدة في الجزائر العاصمة — نصمّم ونطوّر تطبيقات ويب وموبايل ذكية، مع حلول سحابة وأمن سيبراني لفرق عبر أفريقيا وأوروبا والشرق الأوسط.',
    seeWork: 'اطّلع على أعمالنا',
    start: 'ابدأ مشروعًا',
    scroll: 'مرّر للأسفل',
    marquee: [
      'تطبيقات الموبايل',
      'تطوير الويب',
      'تطوير SaaS',
      'السحابة و DevOps',
      'تحليل البيانات',
      'الأمن السيبراني',
    ],
  },
  about: {
    index: '01',
    label: 'من نحن',
    title1: 'هذا',
    title2: 'الاستوديو',
    leadBefore: 'منذ 2014، كودكس شريكك الموثوق لتحويل الأفكار الطموحة إلى ',
    leadAccent: 'برمجيات عاملة',
    leadAfter: ' للمؤسسات والعيادات والأسواق الرقمية والشركات الناشئة عبر ثلاث قارات.',
    body: 'فريق متعدد التخصصات من مهندسين ومصممين واستراتيجيين في الجزائر. نشارك العميل بعمق ثم نصمّم ونبني تطبيقات ذكية بلا صندوق أسود. شاركت كودكس أيضًا في العديد من المعارض والفعاليات التقنية والتصديرية.',
    credentials: 'اعتماداتنا',
    credentialItems: [
      'إدارة جودة معتمدة ISO 9001',
      'تسليم متوافق مع حماية البيانات و GDPR',
      'فريق منتج وتجربة مستخدم حائز على جوائز',
      'اتفاقية توافر 99.9٪ للمنصات المُدارة',
    ],
    expos: 'معارض وفعاليات',
    exposLead:
      'حضور في منصات التقنية والتصدير — للقاء الشركاء والعملاء ومنظومة الرقمنة.',
    expoItems: ['Web Expo', 'Web Summit', 'Algeria Export Fair', 'AFES'],
    stats: [
      { label: 'سنوات الخبرة' },
      { label: 'مشاريع مُسلَّمة' },
      { label: 'عملاء نشطون' },
      { label: 'قارات نخدمها' },
    ],
    tech: 'التقنيات التي نعمل بها',
    algiers: 'كودكس — الجزائر',
  },
  services: {
    index: '02',
    label: 'الخدمات',
    title1: 'ماذا',
    title2: 'نقدم',
    title3: 'حقًا',
    ctaBody: 'تحتاج حلًا تقنيًا مخصصًا لعملك في الجزائر أو خارجها؟ نحدد نطاق كل مشروع على حدة.',
    cta: 'ناقش مشروعك',
    processTitle: 'طريقة عملنا',
    processLead: 'مسار واضح بلا مفاجآت — تعرف دائماً أين وصل مشروعك.',
    processSteps: [
      {
        title: 'الاستكشاف',
        detail:
          'ورشة تحديد النطاق: الأهداف والمستخدمون والقيود والميزانية. تخرج بخطة واضحة ومُسعّرة.',
      },
      {
        title: 'التصميم',
        detail: 'نماذج تفاعلية نعتمدها معاً قبل كتابة أي سطر برمجي.',
      },
      {
        title: 'التطوير',
        detail: 'دورات قصيرة وعروض أسبوعية وكود مُختبَر ومُدقَّق باستمرار.',
      },
      {
        title: 'الإطلاق والمتابعة',
        detail: 'الإطلاق للإنتاج وتدريب فرقك وصيانة مستمرة باتفاقية توفر 99,9%.',
      },
    ],
    readyTitle: 'منتجات جاهزة للإطلاق',
    readyLead:
      'إلى جانب البناء المخصص، لدى كودكس قواعد منتجات مجرّبة — أسرع في الإطلاق وقابلة للتخصيص حسب علامتكم وقواعد عملكم.',
    readyCta: 'اطلب عرضًا / عرض سعر للمنتج',
    readyItems: [
      {
        name: 'VTC',
        detail: 'تطبيق نقل / سائق / توزيع — جاهز للتكييف مع أسطولكم.',
      },
      {
        name: 'Food delivery',
        detail: 'طلبات ومراسلون ومطاعم وتتبع — حزمة توصيل وجبات.',
      },
      {
        name: 'Flexy',
        detail: 'خدمات Flexy / شحن الرصيد للسوق الجزائري.',
      },
      {
        name: 'E-learning',
        detail: 'دورات ومتعلمون ومحتوى ومتابعة — منصة تكوين عن بُعد.',
      },
    ],
    items: [
      {
        title: 'تطبيقات الموبايل',
        detail:
          'تجارب iOS و Android بجودة أصلية من قاعدة واحدة. نصمم للعمل دون اتصال ولشبكات محدودة.',
        tags: ['React Native', 'iOS و Android', 'العمل دون اتصال', 'متاجر التطبيقات'],
      },
      {
        title: 'تطوير الويب',
        detail:
          'تطبيقات ويب سريعة وسهلة الوصول. مواقع تسويقية فورية ولوحات تحكم معقدة تبقى سلسة مع بيانات حقيقية.',
        tags: ['React / Next.js', 'أنظمة تصميم', 'CMS بدون رأس', 'تدقيق الأداء'],
      },
      {
        title: 'تطوير SaaS',
        detail:
          'منتجات متعددة المستأجرين وبرمجيات أعمال — من MVP SaaS إلى المنصات الداخلية. استكشاف، معمارية، بناء ودعم طويل الأمد.',
        tags: ['استكشاف المنتج', 'معمارية متعددة المستأجرين', 'تصميم API', 'تحديث الأنظمة القديمة'],
      },
      {
        title: 'السحابة و DevOps',
        detail:
          'ترحيل، بنية كرمز وخطوط CI/CD لنشر يومي بدلًا من ربع سنوي. قابلة للتوسع ومُسعَّرة حسب الاستخدام الفعلي.',
        tags: ['AWS / Azure', 'Kubernetes', 'Terraform', 'SRE والمراقبة'],
      },
      {
        title: 'تحليل البيانات',
        detail:
          'خطوط أنابيب ومستودعات ولوحات BI تحوّل البيانات التشغيلية إلى قرارات — من أول ETL إلى التنبؤ بمساعدة ML.',
        tags: ['خطوط بيانات', 'لوحات BI', 'التنبؤ', 'دمج ML'],
      },
      {
        title: 'الأمن السيبراني',
        detail:
          'تدقيق أمني، اختبار اختراق ومراقبة على مدار الساعة للبنى التحتية الحرجة. نكتشف الثغرات قبل غيرنا.',
        tags: ['اختبار اختراق', 'تدقيق أمني', 'مركز عمليات أمنية', 'الامتثال'],
      },
    ],
  },
  work: {
    index: '03',
    label: 'أعمال مختارة',
    title1: 'ملاحظات',
    title2: 'ميدانية',
    scrollExplore: 'مرّر للاستكشاف',
    projectsCount: 'مشاريع',
    moreShipped: 'وأكثر من 190 مشروعًا منذ 2014',
    yoursNext: 'مشروعك التالي؟',
    swipeHint: 'اسحب للتصفح · المس للفتح',
    openCase: 'افتح دراسة الحالة',
    highlights: 'أبرز النقاط',
    similar: 'ابدأ مشروعًا مشابهًا',
    close: 'إغلاق دراسة الحالة',
  },
  contact: {
    index: '05',
    label: 'تواصل',
    reply: 'نرد خلال 24 ساعة',
    title1: 'لنتحدث',
    title2: 'الآن',
    name: 'الاسم *',
    email: 'البريد *',
    company: 'الشركة',
    project: 'المشروع *',
    namePh: 'اسمك الكامل',
    emailPh: 'name@company.com',
    companyPh: 'الشركة أو المؤسسة',
    projectPh: 'ماذا تبني؟ الجدول الزمني، الأهداف، والقيود…',
    send: 'إرسال الرسالة',
    preparing: 'جارٍ التحضير…',
    ready: 'جاهز للإرسال',
    sentNote: 'فُتحت مسودة في تطبيق البريد. أرسلها عندما تكون جاهزًا.',
    whatsapp: 'أو راسلنا على واتساب',
    errorRequired: 'يرجى تعبئة الاسم والبريد وتفاصيل المشروع.',
    errorEmail: 'أدخل بريدًا إلكترونيًا صالحًا.',
    emailLabel: 'البريد',
    phoneLabel: 'الهاتف',
    studioLabel: 'الاستوديو',
    maps: 'افتح في الخرائط',
    availability: 'نستقبل مشاريع الربع الرابع من 2026',
    mailSubject: 'استفسار مشروع —',
  },
  projects: {
    index: '03',
    label: 'أعمال مختارة',
    title: 'المشاريع',
    subtitle:
      'منتجات حقيقية بنيناها وما زلنا نصونها — تنقّل، تعليم، صحة، أسواق رقمية وعمليات مصانع.',
    viewCase: 'عرض الحالة',
    backToProjects: 'العودة للمشاريع',
    related: 'مزيد من المشاريع',
    role: 'دورنا',
    challenge: 'التحدي',
    discovery: 'الاستكشاف',
    approach: 'النهج',
    architecture: 'الهندسة',
    delivery: 'التسليم',
    outcome: 'النتيجة',
    howWeBuilt: 'كيف بنيناه',
    stack: 'ملاحظات التقنية',
    highlights: 'أبرز النقاط',
    ctaTitle: 'مشروعك التالي؟',
    ctaBody: 'أخبرنا بما تبنيه. نرد بخطوة تالية واضحة.',
    ctaButton: 'ابدأ مشروعًا',
    notFound: 'تعذّر العثور على المشروع.',
    viewAll: 'كل المشاريع',
  },
  blog: {
    index: '04',
    label: 'المذكرة',
    title: 'ملاحظات ميدانية',
    subtitle:
      'كتابات عملية عن البرمجيات والموبايل والسحابة والأمن — من استوديونا في الجزائر العاصمة.',
    read: 'اقرأ',
    minRead: 'دقيقة قراءة',
    backToBlog: 'العودة إلى المدونة',
    allPosts: 'كل المقالات',
    related: 'المزيد من المذكرة',
    ctaTitle: 'تبني شيئًا؟',
    ctaBody: 'احصل على نطاق سعري تقريبي في دقيقتين — ثم خطوة تالية واضحة مع كودكس.',
    ctaButton: 'عرض سعر مجاني',
    notFound: 'تعذّر العثور على المقال.',
    home: 'الرئيسية',
  },
  legal: {
    index: '06',
    label: 'قانوني',
    terms: 'شروط الاستخدام',
    privacy: 'سياسة الخصوصية',
    updated: 'آخر تحديث',
    also: 'انظر أيضًا',
    contactNote: 'أسئلة حول هذه الصفحات؟',
    notFound: 'تعذّر العثور على الصفحة القانونية.',
  },
  footer: {
    blurb:
      'شريكك التقني الموثوق في الجزائر العاصمة — ويب وموبايل وسحابة وأمن منذ 2014. حضور في Web Expo وWeb Summit وAlgeria Export Fair وAFES.',
    sitemap: 'خريطة الموقع',
    elsewhere: 'حضورنا',
    legal: 'قانوني',
    designed: 'صُمم وطُوّر في الجزائر العاصمة',
    backTop: 'العودة للأعلى',
  },
};

export default ar;
